module.exports = __webpack_public_path__ + "static/media/icon-track-assignment-download.e71fcf99.svg";